export default "/_next/static/src/assets/videos/3954080f7591c6092853da9ac08ad6bd.mp4";